import { useQuery } from "@apollo/client/react";
import GET_CLIENT_CONTACT_INFORMATION from "../../queries/client/getClientContactInformation";
import type { ClientContactInformationModel } from "../../../models/ClientModel";

export const useClientContactInformation = (clientIdentifier: string) => {
  const { data, error, loading, refetch } = useQuery<{
    client: ClientContactInformationModel;
  }>(GET_CLIENT_CONTACT_INFORMATION, {
    variables: {
      clientIdentifier: clientIdentifier,
    },
  });
  return { client: data?.client, error, loading, refetch };
};
